import * as React from 'react'

import { createBrowserRouter } from 'react-router-dom'
import Routes from 'client/routes.js'

const router = createBrowserRouter([{ path: '*', element: <Routes /> }])
export default function () {
  return router
}
